import React, { Component } from 'react';
import cx from 'classnames';
import SVG from 'react-inlinesvg';
import _isEqual from 'lodash.isequal';
import _throttle from 'lodash.throttle';
import { ICON_CONTAINER, ICON_SVG, CLICKABLE } from '../styles/icon';
import onEnterPressed from '../../../common/utils/onEnterPressed';
import ToolTip from '../../ToolTip';
import REQUIRES_STROKE from '../constants/requiresStroke';
import IGNORES_COLOUR from '../constants/ignoresColour';
import allIcons from './getIcons';

import '../styles/_icon.scss';






function getClickableProps(props) {
  if (!props.onClick) {
    return { tabIndex: props.tooltipId && props.tooltipLabel ? 0 : -1 };
  }

  return {
    onClick: props.onClick,
    tabIndex: 0,
    role: 'button',
    onKeyDown: onEnterPressed({ onClick: props.onClick })
  };
}

/**
 * An Icon React component. Renders an SVG icon.
 *
 * @return {React.Element}
 */
export default class Icon extends Component {
  constructor(props) {
    super(props);

    this.state = {
      iconColor: void 0
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Deep equal props to avoid uneccessary re-renders
    return !_isEqual(this.props, nextProps) || !_isEqual(this.state, nextState);
  }

  onIconHover = _throttle(
    () => {
      const { hoverColor } = this.props;
      const { iconColor } = this.state;

      if (!hoverColor || iconColor === hoverColor) {
        return;
      }

      this.setState({ iconColor: hoverColor });
    },
    200,
    { trailing: false }
  );

  onIconUnhover = _throttle(
    () => {
      const { iconColor } = this.state;
      const { color, hoverColor } = this.props;

      if (!hoverColor || iconColor === color) {
        return;
      }

      this.setState({ iconColor: void 0 });
    },
    200,
    { trailing: false }
  );

  /**
   * Attempt to dynamically import an svg file based on an icon name
   *
   * @param {string} iconName
   *
   * @return {void}
   */

  render() {
    const {
      name,
      className,
      onClick,
      size = 25,
      color = 'denim',
      spin,
      hoverColor,
      tooltipId,
      tooltipLabel,
      tooltipPlace,
      tooltipClass,
      animated
    } = this.props;

    if (!allIcons[name] && name !== 'show') {
      return null;
    }
    // $FlowFixMe
    const requiresStroke = REQUIRES_STROKE[name];
    // $FlowFixMe
    const ignoresColour = IGNORES_COLOUR[name];

    // SVG will render in two parent divs (part of the library) and we cannot add styles to these.
    // We add an icon container here so we can style the top most element of Icon.
    return (
      <ToolTip
        id={tooltipId}
        label={tooltipLabel}
        place={tooltipPlace}
        className={tooltipClass}>

        <span
          className={cx(
            'icon-container',
            ICON_CONTAINER({ size, hoverColor, ignoresColour, requiresStroke }),
            {
              'icon-container--animated': animated,
              [CLICKABLE]: onClick,
              spin
            },
            className
          )}
          {...getClickableProps(this.props)}
          onMouseEnter={this.onIconHover}
          onMouseLeave={this.onIconUnhover}
          onFocus={this.onIconHover}
          onBlur={this.onIconUnhover}>

          <SVG
            src={allIcons[name]}
            cacheRequests
            className={cx(
              ICON_SVG({ color, requiresStroke, ignoresColour, size }),
              'icon',
              `icon-${name}`
            )}
            uniquifyIDs
            title=" " />

        </span>
      </ToolTip>);

  }
}

Icon.displayName = 'Icon';

// $FlowFixMe
Icon.defaultProps = {
  className: void 0,
  onClick: void 0
};